// Panel-related constants

export const PANEL_STATUS_OPTIONS = ["Active", "Closed"];

export const PANEL_TYPE_OPTIONS = [
  "Community",
  "Joint Community (2 Communities)",
  "Joint Community (3 Communities)",
  "Independent",
];

export const FEMA_REGION_OPTIONS = [
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
];

export const US_STATES = [
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "Armed Forces (AA)",
  "Armed Forces (AE)",
  "Armed Forces (AP)",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Micronesia",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Islands",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
  "District of Columbia",
];

export const EXPERTISE_OPTIONS = [
  "Coastal Engineering",
  "Hydraulic Engineering",
  "Geotechnical Engineering",
  "Alluvial Fan Engineering",
  "Levee Design and Mapping",
  "1D/2D Floodway Analysis",
  "Storm Surge Modeling",
  "Sediment Transport",
  "Dam Safety",
  "Floodplain Management",
  "FEMA Guidelines",
  "Risk Assessment",
];

export const KEYWORD_OPTIONS = [
  "Flood Mapping",
  "Coastal Hazards",
  "Levee Certification",
  "Storm Surge",
  "Base Flood Elevation",
  "Floodway Analysis",
  "Risk Assessment",
  "Climate Change",
  "Urban Flooding",
  "Dam Safety",
];

export const REGIONS = [
  "Northeast",
  "Southeast",
  "Midwest",
  "Southwest",
  "West Coast",
  "Gulf Coast",
];

export const PANEL_VISIBILITY_OPTIONS = ["PUBLIC", "PRIVATE"];

export const PANEL_DB_STATUS_OPTIONS = [
  "DRAFT",
  "CREATED",
  "PENDING",
  "IN_PROGRESS",
  "PENDING_APPROVAL",
  "DECISION_REACHED",
  "PENDING_PUBLICATION",
  "PUBLISHED",
  "COMPLETED",
  "CANCELLED",
];

// Cadre Application Form Constants
export const EDUCATION_OPTIONS = [
  { value: "Bachelor's Degree", label: "Bachelor's Degree" },
  { value: "Master's Degree", label: "Master's Degree" },
  { value: "Ph.D.", label: "Ph.D." },
  { value: "Professional Degree", label: "Professional Degree" },
];

export const YES_NO_OPTIONS = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
  { value: "NOT_ANSWERED", label: "Not Answered" },
];

export const YES_NO_ONLY_OPTIONS = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

export const PTS_JOINT_VENTURE_OPTIONS = [
  { value: "None", label: "None" },
  { value: "Baker AECOM", label: "Baker AECOM" },
  { value: "RAMPP joint venture", label: "RAMPP joint venture" },
  { value: "STARR joint venture", label: "STARR joint venture" },
];

export const WORK_LEVEL_OPTIONS = [
  { value: "None", label: "None" },
  { value: "National", label: "National" },
  { value: "Regional", label: "Regional" },
  { value: "State", label: "State" },
  { value: "Local", label: "Local" },
  { value: "Community", label: "Community" },
  { value: "Other", label: "Other" },
];

export const NFIP_WORK_LEVEL_OPTIONS = [
  { value: "None", label: "None" },
  { value: "Federal", label: "Federal" },
  { value: "State", label: "State" },
  { value: "Local", label: "Local" },
];

// Rep roles for Panel Creation Step 4
export const REP_ROLES = [
  { value: "COMMUNITY_MEMBER", label: "Community Member" },
  { value: "CLIENT_MEMBER", label: "FEMA Member" },
];

// Project type to rep requirements mapping
export const PROJECT_TYPE_REP_REQUIREMENTS = {
  Community: {
    communityReps: 1,
    clientReps: 1,
    description: "1 FEMA + 1 Community member required",
  },
  "Joint Community (2 Communities)": {
    communityReps: 2,
    clientReps: 1,
    description: "1 FEMA + 2 Community members required",
  },
  "Joint Community (3 Communities)": {
    communityReps: 3,
    clientReps: 1,
    description: "1 FEMA + 3 Community members required",
  },
  Independent: {
    communityReps: 0,
    clientReps: 1,
    description: "1 FEMA member required",
  },
};
